
import { HasConfirmationOfDeleting } from "../abstracts/mixins/HasConfirmationOfDeleting";
import { CRUDEntity } from "../abstracts/CRUDEntity";
import { FormActions } from "../abstracts/mixins/FormActions";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { RelatedEntities } from "../abstracts/mixins/RelatedEntities";
import { Validator, ValidationError } from "../../snippets/Validator";
import { HasAttachments } from "../abstracts/mixins/HasAttachments";
import masks from "../../masks.js";
import Errors from '../../errors.js';

export class Customer extends CRUDEntity {

    #validation_fields = [
        'email',
        'phone',
        'first_name',
        'last_name',
        'address',
        'city',
        'state',
        'zip_code',
    ]

    constructor(id=null) {

        Object.assign(Customer.prototype, FormActions);
        Object.assign(Customer.prototype, EntityModalForm);
        Object.assign(Customer.prototype, RelatedEntities);
        Object.assign(Customer.prototype, HasConfirmationOfDeleting);
        Object.assign(Customer.prototype, HasAttachments);


        super();
        this.setAttachmentCallbackDelete()
        this.entityClass = 'customer';
        this.urlRoot = '/customers';
        this.sectionRootUrl = '/customers';
        this.id = id;

        Customer.prototype.delegatedListnersForButtons = function(type, entityClass) {
            masks.init();
            const validateCb = () => {
                if(this.validationForm(type))
                    $(`#${type}-${entityClass} button#${type}`).attr('disabled',false)
                else
                    $(`#${type}-${entityClass} button#${type}`).attr('disabled',true)
            }
            for(let field of this.#validation_fields){
                $(`#${type}-${entityClass} input[name=${field}]`).on('input',validateCb)
            }
            if(type == 'edit')
                validateCb()
            $(`#${type}-${entityClass} button#${type}`).off();
            $(`#${type}-${entityClass} button#${type}`).on('click', () => {
                if(this.validationForm(type,true)){
                    if (type === 'create') {
                        this.create(this.callbackCloseModal,(response)=>Errors.showAlerts(response.responseJSON.errors));
                    }
                    if (type == 'edit') {
                        this.update(this.callbackCloseModal,(response)=>Errors.showAlerts(response.responseJSON.errors));
                    }
                }
            });
        }
    }


    validationForm(type, isSelectErrorFields=false){
        const formId = `${type}-${this.entityClass}`;
        const data = this.collectDataInForm(formId);
        const validator = new Validator({
            'email': ['required'],
            'phone': ['required', {regexp: /^[0-9]{3}-[0-9]{3}-[0-9]{4}/}],
            'first_name': ['required'],
            'last_name': ['required'],
        });

        let validate_flag = true;

        this.#validation_fields.forEach(element => {
            if (validator.validate(element, data[element])) {
                if(isSelectErrorFields)
                    $('#'+formId+' [name="'+element+'"]').attr('style','');
            }else{
                validate_flag = false;
                if(isSelectErrorFields)
                    $('#'+formId+' [name="'+element+'"]').attr('style','border:2px solid #DB3A57 !important;');
            }
        });

        return validate_flag;
    }
}
